import { SiteContext } from '../../../common';
import { FeatureList, FeaturesSettings, SiteFeature } from '../../models';
import { siteSettingsHttp } from '../site-settings-api';

export const getSiteFeatures = async (
  locale: string,
  siteContext: SiteContext
): Promise<FeaturesSettings> => {
  const features = Object.values(SiteFeature).join(',');
  const url = `/feature/${siteContext}/${locale}?features=${features}`;
  const { data } = await siteSettingsHttp.get<FeatureList>(url);
  return data.reduce<FeaturesSettings>((settings, feature) => {
    return { ...settings, [feature.name]: feature.value };
  }, {});
};
